import React from 'react';
import { withTranslation } from 'react-i18next';
import './kidslanding.css';
import HP_Constants from '../height-predictor-constants/HP_Constants';
import GenderDropDown from './GenderDropDown';
import ToggleSwitch from "./ToggleSwitch";
import { max } from 'moment';


class KidsLandingData extends React.Component {
    // Setting up component default state here
    state = {
        genderType: this.props.heightData.genderType,
        motherHeight: 0,
        fatherHeight: 0,
        defaultMotherHeight: "",
        defaultFatherHeight: "",
        unit: 'cm',
        isToggled: this.props.heightData.isToggled
    };

    onToggle = (e) => {
        if (e.target.checked) {
            sessionStorage.setItem('unit', this.props.componentData.unitInchLabel.value)
            this.props.getUnitType(this.props.componentData.unitInchLabel.value)
            this.setState({
                unit: this.props.t('HeightPredictor_unitFeet')
            })
            this.props.setUnitData(this.props.t('HeightPredictor_unitFeet'))
            document.getElementById("calculate-button-id").disabled = true;
            // if(document.getElementById("mother-height").value.length == 0 && document.getElementById("father-height").value.length == 0 ){
            //     document.getElementById("calculate-button-id").disabled = true;
            // }
            // else{
            //     document.getElementById("calculate-button-id").disabled = false;
            // }
        } else {
            sessionStorage.setItem('unit', this.props.componentData.unitCmLabel.value)
            this.props.getUnitType(this.props.componentData.unitCmLabel.value)
            this.setState({
                unit: this.props.componentData.unitCmLabel.value
            })
            this.props.setUnitData(this.props.componentData.unitCmLabel.value)
            document.getElementById("calculate-button-id").disabled = true;
        }
        this.setState({
            isToggled: !this.state.isToggled,
        })
        this.setState({
            motherHeight: '',
            defaultMotherHeight: '',
            fatherHeight: '',
            defaultFatherHeight: ''
        });



    }

    // Sending default data from Child component to parent component as component loads
    componentDidMount() {
        // sessionStorage.setItem('unit', this.props.componentData.unitCmLabel.value)
        this.setState((prevState, props) => {
            return {
                genderType: props.heightData.genderType,
                motherHeight: props.heightData.motherHeight,
                defaultMotherHeight: props.heightData.motherHeight === 0 ? '' : props.heightData.motherHeight,
                fatherHeight: props.heightData.fatherHeight,
                defaultFatherHeight: props.heightData.fatherHeight === 0 ? '' : props.heightData.fatherHeight,
                unit: !props.heightData.isToggled ? props.componentData.unitCmLabel.value : props.t('HeightPredictor_unitInch'),
                isToggled: props.heightData.isToggled
            };
        }, () => {
            sessionStorage.setItem('unit', this.state.unit)
            this.props.setUnitData(this.state.unit)
            this.props.sendLastPeriodData(this.state.genderType, this.state.motherHeight, this.state.fatherHeight);
        })
        // this.props.sendLastPeriodData('', this.state.motherHeight, this.state.fatherHeight);
    }

    // This method is to validate the values in the input box 
    validateValue = (event) => {
        let compData = this.props.componentData;
        // let unit = sessionStorage.getItem('unit') ? sessionStorage.getItem('unit') : 'cm';
        let maxHeight = 0;
        let minHeight = 0;
        if (this.state.unit === 'cm') {
            maxHeight = Number(compData.maxParentHeight.value);
            minHeight = Number(compData.minParentHeight.value);

        } else {
            maxHeight = Number(compData.maxParentHeightInch.value); //Number('8.2') //
            minHeight = Number(compData.minParentHeightInch.value); //Number('1.8')//
        }


        if (event.target.value !== '' && this.state.isToggled) {
            var minHeightFeet = Math.floor(minHeight / 12)
            var minHeightInches = minHeight % 12
            var maxHeightFeet = Math.floor(maxHeight / 12)
            var maxHeightInches = maxHeight % 12
            var heightInFeetInches = event.target.value.split("'")

            if (heightInFeetInches.length >= 1) {
                if (heightInFeetInches[0] < minHeightFeet) {
                    event.target.value = (minHeightInches !== 0 && minHeightInches > 0)
                        ? (minHeightFeet + "'" + minHeightInches)
                        : minHeightFeet
                }
                else if (heightInFeetInches[0] > maxHeightFeet) {
                    event.target.value = (maxHeightInches !== 0 && maxHeightInches > 0)
                        ? (maxHeightFeet + "'" + maxHeightInches)
                        : maxHeightFeet
                }
                else if (heightInFeetInches.length === 2 && heightInFeetInches[0] == minHeightFeet && heightInFeetInches[1] < minHeightInches) {
                    event.target.value = minHeightFeet + "'" + minHeightInches
                }
                else if (heightInFeetInches.length === 2 && heightInFeetInches[0] == maxHeightFeet && heightInFeetInches[1] > maxHeightInches) {
                    event.target.value = maxHeightFeet + "'" + maxHeightInches
                }
            }
        }
        else if (event.target.value !== '' && !this.state.isToggled) {
            if (event.target.value < minHeight) {
                event.target.value = minHeight
            }
            else if (event.target.value > maxHeight) {
                event.target.value = maxHeight
            }
        }
        this.handleChange(event)
        // if (event.target.name === 'mother') {
        //     this.setState({
        //         motherHeight: event.target.value,
        //         defaultMotherHeight: event.target.value
        //     });
        //     this.props.sendLastPeriodData(this.state.genderType, Number(event.target.value), Number(this.state.fatherHeight));
        // }
        // else {
        //     this.setState({
        //         fatherHeight: event.target.value,
        //         defaultFatherHeight: event.target.value
        //     });
        //     this.props.sendLastPeriodData(this.state.genderType, Number(this.state.motherHeight), Number(event.target.value));
        // }
    }

    // Onchange cheking the value of partner and sending to parent component
    // Cheking Gender based on the element clicked by end-user
    handleChange = (event) => {
        var height = event.target.value
        if (event.target.name === 'mother') {
            this.setState({
                motherHeight: height,
                defaultMotherHeight: height
            });
            // sending data from here to OvulationCalculator.js
            this.props.sendLastPeriodData(this.state.genderType, (this.state.isToggled ? height : Number(height)), (this.state.isToggled ? this.state.fatherHeight : Number(this.state.fatherHeight)));
        }
        else if (event.target.name === 'father') {
            this.setState({
                fatherHeight: height,
                defaultFatherHeight: height
            });
            // sending data from here to OvulationCalculator.js
            this.props.sendLastPeriodData(this.state.genderType, (this.state.isToggled ? this.state.motherHeight : Number(this.state.motherHeight)), (this.state.isToggled ? height : Number(height)));
        }
    };

    getUnitType = (unitType) => {
        let { motherHeight, defaultMotherHeight, fatherHeight, defaultFatherHeight } = this.state;

        // this.setState({

        // })
        // this.setState({
        //     motherHeight: '',
        //     defaultMotherHeight: '',
        //     fatherHeight: '',
        //     defaultFatherHeight: ''
        // });
        this.setState((prevState, props) => {
            return {
                unit: unitType,
                motherHeight: '',
                defaultMotherHeight: '',
                fatherHeight: '',
                defaultFatherHeight: ''
            };
        }, () => {
            this.props.sendLastPeriodData(this.state.genderType, (this.state.isToggled ? this.state.motherHeight : Number(this.state.motherHeight)), (this.state.isToggled ? this.state.fatherHeight : Number(this.state.fatherHeight)));
            this.props.getUnitType(unitType);
        })
        // if(defaultMotherHeight !== '' && defaultFatherHeight !== ''){
        //     if (unitType === 'cm') {
        //         this.setState({
        //             motherHeight: Math.round(33.34 * motherHeight),
        //             defaultMotherHeight: Math.round(33.34 * motherHeight),
        //             fatherHeight: Math.round(33.34 * fatherHeight),
        //             defaultFatherHeight: Math.round(33.34 * fatherHeight)
        //         });

        //     } else {
        //         this.setState({
        //             motherHeight: (0.03 * motherHeight).toFixed(2),
        //             defaultMotherHeight: (0.03 * motherHeight).toFixed(2),
        //             fatherHeight: (0.03 * fatherHeight).toFixed(2),
        //             defaultFatherHeight: (0.03 * fatherHeight).toFixed(2)
        //         });
        //     }
        // }
        // this.props.sendLastPeriodData(this.state.genderType, Number(this.state.motherHeight), Number(this.state.fatherHeight));

        // this.validateValue();
        document.getElementsByName('mother')[0].blur();
        document.getElementsByName('father')[0].blur();
    }

    // This function check text box having only numbers or decimal
    checkNumberOnly = (e) => {
        var key = e.keyCode ? e.keyCode : e.which;
        if (key === 13) {
            document.getElementsByName('mother')[0].blur();
            document.getElementsByName('father')[0].blur();
            this.props.calculateHeight();
        }
        if (e.target.value.length == 4) {
            e.preventDefault()
            // return true
        }
        if (e.target.value.indexOf("'") > -1 && (e.target.value.split("'")[1].length > 2)) {
            e.preventDefault();
        }
        else {
            if (e.target.value.length === 0 && this.state.isToggled) {
                e.target.value = (e.key + "'").toString()
                e.preventDefault()
            }
            else if (e.target.value.length === 3 && this.state.isToggled) {
                var height = e.target.value
                if (height[2] == 1 && key !== 48 && key !== 49) {
                    e.preventDefault()
                }
                else if (height[2] > 1) {
                    e.preventDefault()
                }
            }

            var key = e.keyCode ? e.keyCode : e.which;
            // var regexp = /^\d+(?:\.\d{1,2})?$/;
            // console.log(regexp.test(e.target.value))

            let inputElement = e.target.value;
            // Not allowing entering "'" more than one
            if (key === 39 && inputElement.indexOf(e.key) !== -1) e.preventDefault()
            // Allowing "'" in input box
            if (key === 39) return true
            // Handling below scenario for restricting alphabets
            if (key >= 97 && key <= 122) e.preventDefault()
            // For Preventing entering special Character
            if (key > 31 && (key < 48 || key > 57)) e.preventDefault()
            // Handling special case for character 'e'
            if (key === 101) e.preventDefault()
            else if (!([8, 9, 13, 27, 46, 110, 190].indexOf(key) !== -1 ||
                (key == 65 && (e.ctrlKey || e.metaKey)) ||
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57 && !(e.shiftKey || e.altKey)) ||
                (key >= 96 && key <= 105)
            )) e.preventDefault();
        }
    }

    checkNumberOnlyWithComma = (e) => {
        var key = e.keyCode ? e.keyCode : e.which;
        if (key === 13) {
            document.getElementsByName('mother')[0].blur();
            document.getElementsByName('father')[0].blur();
            this.props.calculateHeight();
        }
        if (e.target.value.length == 3) {
            e.preventDefault()
            // return true
        } else {
            var key = e.keyCode ? e.keyCode : e.which;
            // var regexp = /^\d+(?:\.\d{1,2})?$/;
            // console.log(regexp.test(e.target.value))

            let inputElement = e.target.value;
            // Not allowing entering '.' more than one
            if (key === 46 && inputElement.indexOf(e.key) !== -1) e.preventDefault()
            // Allowing '.' in input box
            if (key === 39) return true
            // Handling below scenario for restricting alphabets
            if (key >= 97 && key <= 122) e.preventDefault()
            // For Preventing entering special Character
            if (key > 31 && (key < 48 || key > 57)) e.preventDefault()
            // Handling special case for character 'e'
            if (key === 101) e.preventDefault()
            else if (!([8, 9, 13, 27, 46, 110, 190].indexOf(key) !== -1 ||
                (key == 65 && (e.ctrlKey || e.metaKey)) ||
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57 && !(e.shiftKey || e.altKey)) ||
                (key >= 96 && key <= 105)
            )) e.preventDefault();
        }
    }

    // On click of Gender setting the gender type
    // Cheking Gender based on the element clicked by end-user
    detectGender = (event) => {
        // this.props.sendLastPeriodData(event.toUpperCase(), Number(this.state.motherHeight), Number(this.state.fatherHeight));
        if (event === 'Boy') {
            this.setState({
                genderType: HP_Constants.BOY_LABEL
            })
            this.props.sendLastPeriodData(HP_Constants.BOY_LABEL, (this.state.isToggled ? this.state.motherHeight : Number(this.state.motherHeight)), (this.state.isToggled ? this.state.fatherHeight : Number(this.state.fatherHeight)));
        } else if (event === 'Girl') {
            this.setState({
                genderType: HP_Constants.GIRL_LABEL
            })
            this.props.sendLastPeriodData(HP_Constants.GIRL_LABEL, (this.state.isToggled ? this.state.motherHeight : Number(this.state.motherHeight)), (this.state.isToggled ? this.state.fatherHeight : Number(this.state.fatherHeight)));
        }
    }

    render() {
        const { t } = this.props;
        let { componentData } = this.props;
        return (
            <>
                <div className="form-group">
                    <label>{componentData.genderTitle.value}</label>
                    <GenderDropDown componentData={componentData} detectGender={this.detectGender} defaultSelectedGender={this.state.genderType === "" ? 'Select Gender' : this.state.genderType} />
                </div>
                <div className="form-group">
                    <label>{componentData.unitTitle.value}</label>
                    <div className="toggle-switch-value">
                        {/* <ToggleSwitch componentData={componentData} getUnitType={this.getUnitType} /> */}
                        <div className="switch-box-wrapper">
                            <p className={this.state.isToggled ? "unit-text disabled-unit-text" : "unit-text"}>{this.props.componentData.unitCmLabel.value}</p>
                            <label className="toggle-unit-switch">
                                <input type="checkbox" checked={this.state.isToggled} onChange={this.onToggle} />
                                <span className="switch" />
                            </label>
                            <p className={!this.state.isToggled ? "unit-text disabled-unit-text" : "unit-text"}>{this.props.componentData.unitInchLabel.value}</p>
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label>{componentData.parentOneTitle.value}
                        {
                            <a className="ttlink" alt={this.state.unit == 'cm' ? t('HeightPredictor_ParentOnePlaceholder_centimeters') : t('HeightPredictor_ParentOnePlaceholder')}>
                                <i className="fa fa-question-circle"></i>
                                <span>{this.state.unit == 'cm' ? t('HeightPredictor_ParentOnePlaceholder_centimeters') : t('HeightPredictor_ParentOnePlaceholder')}</span>
                            </a>
                        }
                    </label>

                    <div className="mother">
                        <input type="text" placeholder={this.state.unit == 'cm' ? t('HeightInCentimeters_Example_Placeholder') : t('HeightInFeet_Example_Placeholder')} name="mother" id="mother-height" value={this.state.defaultMotherHeight} onKeyPress={this.checkNumberOnly}
                            onChange={this.handleChange} onBlur={this.validateValue} autoComplete="off" min="50" max={6} step=".01" maxLength={4} />
                        {this.state.defaultMotherHeight !== '' && <span className="input-height-unit">{this.state.unit}</span>}
                    </div>
                </div>

                <div className="form-group">
                    <label>{componentData.parentTwoTitle.value}
                        {
                            <a className="ttlink" alt={this.state.unit == 'cm' ? t('HeightPredictor_ParentTwoPlaceholder_centimeters') : t('HeightPredictor_ParentTwoPlaceholder')}>
                                <i className="fa fa-question-circle"></i>
                                <span>{this.state.unit == 'cm' ? t('HeightPredictor_ParentTwoPlaceholder_centimeters') : t('HeightPredictor_ParentTwoPlaceholder')}</span>
                            </a>
                        }
                    </label>
                    <div className="father">
                        <input type="text" placeholder={this.state.unit == 'cm' ? t('HeightInCentimeters_Example_Placeholder') : t('HeightInFeet_Example_Placeholder')} name="father" id="father-height" value={this.state.defaultFatherHeight} onKeyPress={this.checkNumberOnly}
                            onChange={this.handleChange} onBlur={this.validateValue} autoComplete="off" min="50" max={6} step=".01" maxLength={4} />
                        {this.state.defaultFatherHeight !== '' && <span className="input-height-unit">{this.state.unit}</span>}
                    </div>
                </div>
            </>
        )
    }
}



export default withTranslation()(KidsLandingData);